import { Link } from 'react-router-dom';
import { cases, hotRanking, categories } from '@/mocks/cases';
import { EvidenceTag } from '@/components/feature/EvidenceTag';

export default function Hero() {
  const featured = cases[0];
  const featuredCategory = categories.find((cat) => cat.id === featured.categoryId);

  const stats = [
    { value: '1,280+', label: '累计收录材料' },
    { value: '316', label: '已完成交叉核实' },
    { value: '4 类', label: '证据形式覆盖' },
  ];

  return (
    <section className="border-b border-background-200 bg-gradient-to-b from-background-100 to-background-50">
      <div className="mx-auto max-w-[1280px] px-4 py-10 md:px-6 md:py-14">
        <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs text-primary-700">
          <i className="ri-flashlight-line"></i>
          今日新增 12 条材料 · 4 条完成交叉核实
        </span>
        <h1 className="mt-4 max-w-3xl font-heading text-3xl font-black leading-tight text-foreground-950 md:text-5xl">
          网红爆料网 · 让每一条爆料都<span className="text-primary-600">有据可查</span>
        </h1>
        <p className="mt-4 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
          我们坚持实锤为本，集中展示录音、视频证据、合同照片与转账记录。每一条爆料都会附上原始材料与核实状态，让真相经得起推敲。
        </p>

        <div className="mt-6 flex flex-wrap gap-6">
          {stats.map((s) => (
            <div key={s.label}>
              <p className="font-heading text-2xl font-bold text-foreground-950">{s.value}</p>
              <p className="text-xs text-foreground-500">{s.label}</p>
            </div>
          ))}
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-12">
          <article className="overflow-hidden rounded-lg border border-background-200 bg-background-50 lg:col-span-7">
            <Link to={`/case/${featured.slug}`} className="group block">
              <div className="relative h-52 w-full overflow-hidden bg-background-200 md:h-72">
                <img
                  src={featured.cover}
                  alt={featured.coverAlt}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-foreground-950/10 to-transparent"></div>
                <div className="absolute bottom-3 left-3 flex flex-wrap items-center gap-2">
                  <span className="rounded-md bg-primary-600 px-2 py-1 text-xs text-background-50">焦点爆料</span>
                  <span className="rounded-md bg-foreground-950/70 px-2 py-1 text-xs text-background-50">
                    {featuredCategory?.name}
                  </span>
                </div>
              </div>
            </Link>
            <div className="p-5">
              <h2 className="font-heading text-xl font-bold leading-snug text-foreground-950 md:text-2xl">
                <Link to={`/case/${featured.slug}`} className="hover:text-primary-600">
                  {featured.title}
                </Link>
              </h2>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{featured.summary}</p>
              <div className="mt-3 flex flex-wrap items-center gap-2">
                <span className="inline-flex items-center gap-1 rounded-md bg-primary-100 px-2 py-1 text-xs text-primary-700">
                  <i className="ri-checkbox-circle-line"></i>
                  {featured.status}
                </span>
                {featured.evidence.map((type) => (
                  <EvidenceTag key={type} type={type} />
                ))}
              </div>
            </div>
          </article>

          <div className="lg:col-span-5">
            <div className="h-full rounded-lg border border-background-200 bg-background-50 p-5">
              <div className="flex items-center justify-between">
                <h2 className="font-heading text-lg font-bold text-foreground-950">爆料热榜</h2>
                <span className="text-xs text-foreground-500">按近 7 日阅读量</span>
              </div>
              <ol className="mt-4 space-y-3">
                {hotRanking.map((item, index) => {
                  const target = cases.find((c) => c.id === item.id);
                  return (
                    <li key={item.id}>
                      <Link to={`/case/${target?.slug ?? ''}`} className="group flex items-start gap-3">
                        <span
                          className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-xs font-bold ${
                            index < 3 ? 'bg-primary-600 text-background-50' : 'bg-background-200 text-foreground-600'
                          }`}
                        >
                          {index + 1}
                        </span>
                        <span className="text-sm leading-snug text-foreground-800 group-hover:text-primary-600">
                          {item.title}
                        </span>
                      </Link>
                    </li>
                  );
                })}
              </ol>
              <Link
                to="/cases"
                className="mt-5 flex items-center justify-center gap-1 rounded-md bg-secondary-100 px-4 py-2.5 text-sm font-medium text-secondary-900 transition-colors hover:bg-secondary-200"
              >
                查看完整榜单
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}